module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABLklEQVQ4jY2T4VHCUBCEPzIWQAemhFCBUIF0AFTgUIFJBWgFYgVIBeS3f6ADKcGxAmeZPeeMicPNZPLy7t3uvr3LiK93OlEBB+AMzIDP7oEcRed77GJF6fX4WoBcPPMjNbtrATYuUOHJzwqYAnUiqfoA5sASWLswYgs0wG1SePTZS4SJHzZr8o/ao31pTSil7Y3RSm8MRZ2u1xrsRYRSsDPAEHtphU++Yt5rCsvZe7Mv5t5rUu5sfxZhYut21T0Ad85vOi29kOY2DinIg1S5rcSEFikhlkXP5J2c3/v7YJAHgYSJOqCh0VrIr37rnopos3zQW0TyZiUAFastb8CzkZXUwZhKMT4m+TJRYNsYJM2C+qqEQGIa750TuBT+ifw7y0Sx/IypVahYbAL/HcA3/U1UG3gBoZwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_icon_humidity.png
// module id = AiXR
// module chunks = 4